import React, { useEffect, useState } from 'react'
import wxz from '@/assets/images/wxz.svg'
import xz from '@/assets/images/xz.svg'
import { Styles } from 'jss'
import { createUseStyles } from 'react-jss'

const styles = createUseStyles({
    baseRadio: {
        display: 'inline-flex',
        'align-items': 'center',
        height: '22px',
        color: '#333',
        cursor: 'pointer',

        '& > img': {
            width: '20px',
            height: ' 20px',
            'margin-right': '10px',
        },

        '& > span': {
            display: 'inline-block',
            fontSize: '14px',
        },
    },

    isChecked: {
        color: '#14CC9B',
        fontWeight: '600',
    },
})

interface IProps {
    label: number | any
    value: number | any
    name?: string
    style?: Styles
    canCancal?: boolean
    onChange: () => void
}

export const BaseRadio: React.FC<IProps> = props => {
    const classes = styles()
    const [checked, setChecked] = useState(false)
    useEffect(() => {
        if (props.label === props.value) {
            setChecked(true)
        } else {
            setChecked(false)
        }
    }, [props])

    return (
        <label
            className={[classes.baseRadio, checked ? classes.isChecked : ''].filter(Boolean).join(' ')}
            style={props.style}
            htmlFor={props.name}
            onClick={props.onChange}
        >
            <input type="radio" hidden name={props.name} value={props.label} />
            {checked ? <img src={xz} alt="选择" /> : <img src={wxz} alt="未选择" />}
            <span>{props.children}</span>
        </label>
    )
}
